'use client'

import { useState } from 'react'
import { cx } from '@/app/lib/utils'
import { groupClickMeta } from '../clickTracking'
import { FooterLink } from '../FooterLink'
import type { FooterLinkGroup } from '../types'
import styles from './FooterNavAccordion.module.scss'

interface FooterNavAccordionProps {
  columns: readonly FooterLinkGroup[]
}

export function FooterNavAccordion({ columns }: FooterNavAccordionProps) {
  const [openId, setOpenId] = useState<string | null>(null)

  function toggle(id: string) {
    setOpenId((prev) => (prev === id ? null : id))
  }

  return (
    <div className={styles.accordion}>
      {columns.map((group) => {
        const isOpen = openId === group.id
        const triggerId = `footer-acc-trigger-${group.id}`
        const panelId = `footer-acc-panel-${group.id}`

        return (
          <div key={group.id} className={styles.item}>
            <button
              type="button"
              id={triggerId}
              className={styles.trigger}
              aria-expanded={isOpen}
              aria-controls={panelId}
              onClick={() => toggle(group.id)}
            >
              <span className={styles.title}>{group.title}</span>
              <span className={cx(styles.chevron, isOpen && styles.chevronOpen)} aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" focusable="false">
                  <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </button>
            <div
              id={panelId}
              role="region"
              aria-labelledby={triggerId}
              hidden={!isOpen}
            >
              <div className={styles.panelInner}>
                <ul className={styles.linkList}>
                  {group.links.map((link) => (
                    <li key={link.id}>
                      <FooterLink
                        item={link}
                        className={styles.link}
                        textClassName={styles.text}
                        tracking={groupClickMeta(group)}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
